import { signal } from "@preact/signals";
import { useEffect } from "preact/hooks";
import type { User } from "@orderman/shared";
import { users, usersLoading, login, loadUsers } from "../state/auth.js";
import { manualJoin } from "../state/join.js";
import { deviceUnassigned, pollAssignment } from "../state/assignment.js";
import { deviceName, deviceOwnerClass } from "../state/config.js";

const picked = signal<User | null>(null);
const pinBuf = signal("");
const error = signal("");

// Gerätename (aus dem Inventar) — hilft, das physische Handy beim Zuordnen im Portal zu erkennen.
function DeviceTag() {
  return deviceName.value ? <div class="device-tag">📱 {deviceName.value}</div> : null;
}

// „Gerät neu einrichten" (anderen Code eingeben, Event wechseln). NICHT für Betreiber-Geräte —
// die werden über das Inventar/Zuweisung verwaltet, nicht per Code.
function JoinLink() {
  if (deviceOwnerClass.value === "betreiber") return null;
  return (
    <div class="setup-box">
      <button class="btn-secondary" onClick={() => (manualJoin.value = true)}>
        📲 Gerät neu einrichten (anderer Code)
      </button>
    </div>
  );
}

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "⌫", "0", "OK"];

function press(k: string): void {
  if (k === "⌫") pinBuf.value = pinBuf.value.slice(0, -1);
  else if (k === "OK") {
    if (picked.value && login(picked.value, pinBuf.value)) {
      picked.value = null;
      pinBuf.value = "";
      error.value = "";
    } else {
      error.value = "Falscher PIN";
      pinBuf.value = "";
    }
  } else if (pinBuf.value.length < 6) pinBuf.value += k;
}

export function Login() {
  // Nicht zugewiesen → NICHT das (gecachte) Personal des letzten Events nachladen.
  useEffect(() => { if (!deviceUnassigned.value) void loadUsers(); }, []);
  const active = users.value.filter((u) => u.isActive);

  if (!picked.value) {
    return (
      <div class="login">
        <div class="login-title">Anmelden</div>
        <DeviceTag />
        {active.length === 0 ? (
          <div class="empty">
            {usersLoading.value
              ? "Lade Personal…"
              : deviceUnassigned.value
                ? "Dieses Gerät ist noch keiner Veranstaltung zugewiesen."
                : "Kein Personal vorhanden."}
            <br />
            {deviceUnassigned.value
              ? "Weise es unter obigem Namen in Verwaltung → Geräte einer Veranstaltung zu — danach lädt das Handy automatisch."
              : "Personal in der Konsole anlegen, dann neu laden."}
            <br />
            <button
              class="btn-secondary"
              style="margin-top:16px"
              onClick={() => (deviceUnassigned.value ? void pollAssignment() : void loadUsers())}
            >
              {deviceUnassigned.value ? "Erneut prüfen" : "Neu laden"}
            </button>
            <JoinLink />
          </div>
        ) : (
          <>
            <div class="user-grid">
              {active.map((u) => (
                <button
                  key={u.id}
                  class="user-btn"
                  onClick={() => {
                    picked.value = u;
                    pinBuf.value = "";
                    error.value = "";
                  }}
                >
                  {u.name}
                </button>
              ))}
            </div>
            <JoinLink />
          </>
        )}
      </div>
    );
  }

  return (
    <div class="login">
      <button class="back" onClick={() => (picked.value = null)}>
        ‹ zurück
      </button>
      <div class="login-title">{picked.value.name}</div>
      <div class="tablepad-display">{pinBuf.value ? "•".repeat(pinBuf.value.length) : "PIN"}</div>
      {error.value && <div class="login-error">{error.value}</div>}
      <div class="keypad">
        {KEYS.map((k) => (
          <button key={k} class={`key ${k === "OK" ? "key-ok" : ""} ${k === "⌫" ? "key-del" : ""}`} onClick={() => press(k)}>
            {k}
          </button>
        ))}
      </div>
    </div>
  );
}
